<app-loader [show]="showLoader"></app-loader>

<div class="table-responsive py-3" [class.d-none]="showLoader">
    <table class="table-striped" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
        <thead>
            <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Username</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Website</th>
            </tr>
        </thead>
        <tbody *ngIf="users.length >= 1">
            <tr *ngFor="let user of users">
                <td>{{user?.id}}</td>
                <td>{{user?.name}}</td>
                <td>{{user?.username}}</td>
                <td>{{user?.email}}</td>
                <td>{{user?.phone}}</td>
                <td>{{user?.website}}</td>
            </tr>
        </tbody>
    </table>
</div>